import apiClient from '@/api/client'
import { AuthState } from '@/types/field'
import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

const token = cookies.get('token')

const initialState: AuthState = {
    auth: 'SUPER_ADMIN', // ORGANIZATION
    isAuth: token ? true : false,
    isLogin: token ? true : false,
    token: token ? token : '',
    loading: false,
    message: '',
    entities: {}
}


const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        logIn: (state, action) => {
            const token = action.payload.token
            if (!token) return
            cookies.set('token', JSON.stringify(token))
            apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
            state.token = token
            state.isAuth = action.payload.isAuth
            state.isLogin = action.payload.isLogin
        },
        logOut: (state) => {
            cookies.remove('token')
            cookies.remove('go_back')
            state.token = ''
            state.isAuth = false
            state.isLogin = false
        },
        userSession: (state, action) => {
            if (action.payload.data) {
                state.entities = action.payload.data
                state.isAuth = true
            } else {
                cookies.remove('token')
                cookies.remove('go_back')
                state.isAuth = false
                state.isLogin = false
            }
        },
        handleSession: (state) => {
            state.isLogin = !state.isLogin
        },
        authSuccess: (state) => {
            state.loading = false
        },
        authFailure: (state) => {
            state.loading = false
        }
    }
})

export const {
    logIn,
    logOut,
    authSuccess,
    authFailure,
    userSession,
    handleSession
} = authSlice.actions

export default authSlice.reducer
